"use strict";

$(document).ready(function(){
     
    Proj.init();
    Proj.fancybox();

    Proj.PopupForms.init('.get-form');

    Proj.processFormField(".form-form_contact");

    Proj.ScrollTo(".scroll");

    if(Proj.interfaceName == "home_page") {
        Proj.homeClientsSlider('.home-client-slider');
        Proj.SubmitAjaxForm.init(".form-form_mail", 1);
        Proj.homeSwitchBlock(".block--home-switch");
    }

    if(Proj.interfaceName == "prod_page") {
        Proj.prodDoubleSlider('.product-gallery--big','.product-gallery--small');
        Proj.prodTabs('.tabs');
    }

    if(Proj.interfaceName == "work") {
        Proj.workDoubleSlider('.work__gallery--big','.work__gallery--small');
        Proj.prodTabs('.tabs');
    }

    if(Proj.interfaceName == "prod_group") {
        //Proj.prodFloatMenu();
    }

    if(Proj.interfaceName == "works_cat") {
        Proj.dropDownFilterSelect(".drop-down-select", ".form-filter");
    }

    if(Proj.interfaceName == "page") {
       Proj.pageGallerySlider(".gallery");
    }

});